import { Injectable, InjectionToken, Injector } from '@angular/core';
import { CommonApp2dService } from './common-app-2d-service';
import { CONFIG_CONTEXT } from '../../enum/config-context.enum';
import { CD_CUSTOM_SERVICE } from '../../providers/closet-doors-custom.provider';
import { FE_SERVICE } from '../../providers/fence.providers';
import { DB_SERVICE } from '../../providers/decking-boards.providers';
import { ClosetDoorsStandardService } from './applications/closet-doors-standard.service';
import { WB_SERVICE } from 'src/app/providers/workbench.provider';
import { CA_SERVICE } from 'src/app/providers/carpentry.providers';
import { KI_SERVICE } from 'src/app/providers/kitchen.providers';
import { ST_SERVICE } from 'src/app/providers/storage.providers';
import { BA_SERVICE } from 'src/app/providers/bathroom.providers';
import { BK_SERVICE } from 'src/app/providers/basket.providers';
import { BA_HBM_SERVICE } from 'src/app/providers/bathroom-hbm.providers';

@Injectable()
export class ServiceManager {
  private injectionTokens: Map<string, InjectionToken<CommonApp2dService>> = new Map([
    [CONFIG_CONTEXT.CLOSET_DOORS_CUSTOM, CD_CUSTOM_SERVICE],
    [CONFIG_CONTEXT.FENCE, FE_SERVICE],
    [CONFIG_CONTEXT.DECKING_BOARDS, DB_SERVICE],
    [CONFIG_CONTEXT.WORKBENCH, WB_SERVICE],
    [CONFIG_CONTEXT.CARPENTRY, CA_SERVICE],
    [CONFIG_CONTEXT.KITCHEN, KI_SERVICE],
    [CONFIG_CONTEXT.STORAGE, ST_SERVICE],
    [CONFIG_CONTEXT.BATHROOM_V2, BA_SERVICE],
    [CONFIG_CONTEXT.BATHROOM, BA_HBM_SERVICE],
    [CONFIG_CONTEXT.BASKET, BK_SERVICE],
  ]);

  private services = new Map<InjectionToken<CommonApp2dService>, CommonApp2dService>();

  constructor(
    private injector: Injector,
    public cdStandardService: ClosetDoorsStandardService
  ) {}

  public getService(context: string): CommonApp2dService {
    if (context === CONFIG_CONTEXT.CLOSET_DOORS_STANDARD) {
      return this.cdStandardService;
    }

    if (!this.injectionTokens.has(context)) {
      return undefined;
    }

    let token = this.injectionTokens.get(context);
    if (!this.services.has(token)) {
      this.services.set(token, this.injector.get(token));
    }

    return this.services.get(token);
  }
}
